module.exports = __webpack_public_path__ + "static/media/img_snake_end_right.8f475484.svg";